export default {
    heading: "Welcome to our website!",
    description: "Here you can participate in different salons, using only one account. Although it's empty, new salons will be available soon."
} as ArchiveEmptyOptions